import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RouteEnum } from '@app/constants/route.enum';
import { AppStore } from '@app/stores/app.store';

export const authGuard: CanActivateFn = () => {
  const appStore = inject(AppStore);
  const router = inject(Router);
  if (!appStore.isLoggedIn()) {
    return router.createUrlTree([RouteEnum.HOME]);
  }
  return true;
};
